export default __webpack_public_path__ + "static/media/strDup.9234e57d.png";